const SUBMENU_LIST = 'SUBMENU_LIST';

const CURRENT_SUBMENU = 'CURRENT_SUBMENU';

const MOVE_PLACE = 'MOVE_PLACE';

const MAINMENU_MOVEPLACE = 'MAINMENU_MOVEPLACE';


const state = {
    subMenuList: [],
    currentSubMenu: {},
    currentMovePlace: {},
    mainMenuMovePlace: 0,
}

const getters = {

}

const actions = {
    setSubmenuList({
        commit
    }, list) {
        commit(SUBMENU_LIST, list);
    },
    setCurrentSubMenu({
        commit
    }, menu) {

        commit(CURRENT_SUBMENU, menu);
    },
    setCurrentMovePlace({
        commit
    }, place) {
        console.log('place=>', place)
        commit(MOVE_PLACE, place);
    },
    setMainMenuMovePlace({
        commit
    }, place) {
        commit(MAINMENU_MOVEPLACE, place);
    }


}

const mutations = {
    [SUBMENU_LIST](state, list) {
        state.subMenuList = list;
    },
    [CURRENT_SUBMENU](state, menu) {
        state.currentSubMenu = menu;
    },
    [MOVE_PLACE](state, place) {
        state.currentMovePlace = place;
    },
    [MAINMENU_MOVEPLACE](state, place) {
        state.mainMenuMovePlace = place;
    }
}

export const menu = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}